<template>
  <div>
    <div class="father">
      <div v-for=" timeItem,index in timeList" :key="index">
          <PopTable
          :timeItem="timeItem"
          :allTimearr="allTimearr"
          @saveChange='saveChange'
          ></PopTable>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import PopTable from './quotaWait-confirmed-pop-table.vue'
export default {
  name: "quotaWait-confirmed-pop-form",
  props: {
    popDataitem: { type: [], default: () => [] },
  },
  components: {
    PopTable
  },
  data() {
    return {
      popData: [],
      timeList:[],
      allTimearr:[]
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {},
  created() {
    // console.log(this.popDataitem, "配额修改/确认 详情---孙组件--form");
    this.popData = this.popDataitem.data;
    // console.log(this.popData, "配额修改/确认 详情---孙组件--form");
    this.init();
  },
  mounted() {},
  updated() {},
  methods: {
    init() {
      this.timeListhandle(this.popData)
    },
    timeListhandle (val) {
            let dataList = val
            let subArr = []
            for (let i = 0; i < dataList.length; i++) {
                for (let j = 0; j < dataList[i].curAssignList.length; j++) {
                    subArr.push(
                        {
                            'curAssignObj':dataList[i].curAssignList[j],
                            'themeDetail' :dataList[i].themeDetail
                        }
                    )   
                }
            }         
            // console.log(subArr,'subArr');
            let subArr0 = []
            let subArr1 = []
            let subArrall = []
            for (let item of subArr) {
              subArrall.push(item)
              if (item.themeDetail.needTransitions == 0) {
                // 不转场
                subArr0.push(item)
              } else if (item.themeDetail.needTransitions == 1)  {
               // 转场
               subArr1.push(item)
              }
            }
            let arrArr = []
            // 不转场
            let object = {} 
            subArr0.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.curAssignObj           
            if (!object[0]) {           
                object[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object[0].children.push(item)        
            })
            if (Object.values(object).length > 0) {
              arrArr.push(Object.values(object)[0])
            }
            // 转场
            let object1 = {} 
            subArr1.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.curAssignObj           
            if (!object1[0]) {           
                object1[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object1[0].children.push(item)        
            })
            if (Object.values(object1).length > 0) {
              arrArr.push(Object.values(object1)[0])
            }
            // 全部
            let object2 = {}
            subArrall.forEach((item) => {  
            let { assignStartTime,assignEndTime } = item.curAssignObj           
            if (!object2[0]) {           
                object2[0] = {          
                    assignStartTime,
                    assignEndTime,
                    children: []           
                }
            }
            object2[0].children.push(item)        
            })
            this.allTimearr = Object.values(object2)[0]
            // console.log(arrArr,'arrArr')
            // this.timeList = Object.values(object1)
            this.timeList = arrArr
            // console.log( this.timeList,' this.timeList');
        },
    // 保存变更
    saveChange (item) {
      this.$emit("saveChange",item)
    },
  },
};
</script>
<style lang="scss" scoped>
.father{
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 0px 0px 0px;
}
</style>
